import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import { FiContentLanguageSharedService } from '@fi-shared/fi-content-language-shared/fi-content-language-shared.service';
import { IContentLanguage } from '@fi-shared/fi-content-language-shared/fi-content-language-shared';

@Component({
    selector: 'fi-translation-radio-group',
    template: `
        @if (isHeadingShown) {
            <p class="fi-translation-heading">{{ 'common.translation' | fiAppText }}</p>
        }

        <mat-radio-group [(ngModel)]="selectedLanguageId" (ngModelChange)="changeSelectedLanguageId()">
            @for (contentLanguage of availableContentLanguages; track contentLanguage.Id) {
                <mat-radio-button [value]="contentLanguage.Id">
                    {{ contentLanguage.Name }}
                </mat-radio-button>
            }
        </mat-radio-group>
    `,
    styleUrls: ['./fi-translation-radio-group.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-translation-radio-group' },
    standalone: false,
})
export class FiTranslationRadioGroupComponent implements OnInit {
    @Input() availableContentLanguages: IContentLanguage[] = [];
    @Input() selectedLanguageId: number;
    @Output() selectedLanguageIdChange = new EventEmitter<number>();
    @Input() isHeadingShown = true;

    constructor(private fiContentLanguageSharedService: FiContentLanguageSharedService) {}

    public ngOnInit(): void {
        if (!this.availableContentLanguages?.length) {
            this.availableContentLanguages = this.fiContentLanguageSharedService.getContentLanguages();
        }
    }

    protected changeSelectedLanguageId(): void {
        this.selectedLanguageIdChange.emit(this.selectedLanguageId);
    }
}
